const ICON_SIZES = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32,
};
const formatSize = (size) => {
    if (typeof size === 'number')
        return size;
    return parseInt(size.replace('px', ''));
};
const resolveSize = (size) => typeof size === 'number' ? size : ICON_SIZES[size];
const useIconProps = (iconProps) => {
    const { width, height, size = 32, style, className, onClick, color, } = iconProps;
    return {
        width: width ? formatSize(width) : resolveSize(size),
        height: height ? formatSize(height) : resolveSize(size),
        style: Object.assign(Object.assign({}, style), { color }),
        className,
        onClick,
    };
};
export default useIconProps;
